import{useState}from'react'
import{supabase}from'../supabase'

export default function Contacts({eventId,contacts,onSaved,orgId}){
const[rows,setRows]=useState(contacts.length>0?contacts:[{name:'',email:'',phone:'',company:'',role:'artist'}])
const[saving,setSaving]=useState(false)

function updateRow(i,field,value){
const updated=[...rows]
updated[i]={...updated[i],[field]:value}
setRows(updated)}

function addRow(){setRows([...rows,{name:'',email:'',phone:'',company:'',role:'other'}])}

async function handleSave(){
setSaving(true)
await supabase.from('contacts').delete().eq('event_id',eventId)
const payload=rows.filter(r=>r.name).map(r=>({event_id:eventId,org_id:orgId,name:r.name,email:r.email||'',phone:r.phone||'',company:r.company||'',role:r.role||'other'}))
await supabase.from('contacts').insert(payload)
setSaving(false)
onSaved()}

return(<div>
{rows.map((row,i)=>(<div key={i} style={{display:'flex',gap:'8px',marginBottom:'8px',flexWrap:'wrap'}}>
<select value={row.role} onChange={e=>updateRow(i,'role',e.target.value)} className='input' style={{width:'130px'}}>
<option value='artist'>Artist</option>
<option value='agent'>Agent</option>
<option value='tour_manager'>Tour Manager</option>
<option value='production'>Production</option>
<option value='internal_staff'>Internal Staff</option>
<option value='vendor'>Vendor</option>
<option value='other'>Other</option>
</select>
<input className='input' placeholder='Name' value={row.name} onChange={e=>updateRow(i,'name',e.target.value)} style={{flex:1,minWidth:'120px'}}/>
<input className='input' placeholder='Email' value={row.email||''} onChange={e=>updateRow(i,'email',e.target.value)} style={{flex:1,minWidth:'120px'}}/>
<input className='input' placeholder='Phone' value={row.phone||''} onChange={e=>updateRow(i,'phone',e.target.value)} style={{width:'120px'}}/>
<input className='input' placeholder='Company' value={row.company||''} onChange={e=>updateRow(i,'company',e.target.value)} style={{flex:1,minWidth:'120px'}}/>
</div>))}
<div style={{display:'flex',gap:'8px',marginTop:'8px'}}>
<button className='btn-secondary' onClick={addRow}>+ Add Contact</button>
<button className='btn-primary' onClick={handleSave} disabled={saving}>{saving?'Saving...':'Save Contacts'}</button>
</div>
</div>)}